import React ,{useState,useEffect} from 'react'
import {motion} from 'framer-motion'
import {HiChevronLeft, HiChevronRight} from 'react-icons/hi'
import Cookies from 'js-cookie'
import { useTranslation} from "react-i18next";

import {AppWrap,MotionWrap} from '../../wrappers'
import {urlFor,client} from '../../client'

import './Testimonials.scss'

const Testimonials = () => {
  const { t } = useTranslation();
  const [brands, setBrands] = useState([])
  const [testimonials, setTestimonials] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)

  const handleClick= (index) => {
    setCurrentIndex(index)
  }

  useEffect(() => {
    const currentLocale = Cookies.get('i18next') ?? 'en'
    const testimonialsQuery = `*[_type=="testimonials"  && locale == "${currentLocale}"]`
    const brandsQuery = '*[_type=="brands"]'

    client.fetch(testimonialsQuery)
      .then((data)=> {
        setTestimonials(data)
      })
      client.fetch(brandsQuery)
      .then((data)=> {
        setBrands(data)
      })
  }, [Cookies.get('i18next')])

  const testimonial=testimonials[currentIndex]
  return (
   <>
   {testimonials.length && (
     <>
     <div className='app__testimonial-item app__flex'>
       <img className ="profil" src={urlFor(testimonial.imageurl)} alt="testimonial" />
       <div className='app__testimonial-content'>
         <p className='p-text'>{testimonial.feedback}</p>
         <div className='app__testimonial-details'>
           <h4 className='bold-text'>{testimonial.name}</h4>
           <h5 className='p-text'>{testimonial.position} {t('at')} <strong>{testimonial.organization}</strong></h5>
         </div>
       </div>
       <img className ="app__company-logo" src={urlFor(testimonial.companyLogo)} alt={testimonial.companyLogo}/>
     </div>

     <div className='app__testimonial-btns app__flex'>
         <div className='app__flex' onClick={() => handleClick(currentIndex === 0 ? testimonials.length-1 :currentIndex-1)}>
           <HiChevronLeft/>
         </div>
         <div className='app__flex' onClick={() => handleClick(currentIndex === testimonials.length-1 ? 0 :currentIndex+1)}>
           <HiChevronRight/>
         </div>

       </div>
     </>
   )}

   <div className='app__testimonial-brands app__flex'>
     {brands.map((brand)=> (
       <motion.div
       whileInView={{opacity:[0,1]}}
       transition= {{duration:0.5,type:'tween'}}
       key={brand._id}
       >
          <a href={brand.website} target='_blank' rel='noreferrer noopener'>
         <img src={urlFor(brand.imgUrl)} alt={brand.name}/>
         </a>
       </motion.div>
     ))}
   </div>
   </>
  )
}

export default AppWrap(
  MotionWrap(Testimonials,'app__testimonial'),
  'testimonials',
  "app__primarybg"
  )